import { html, css } from 'lit-element';
import { FormElement } from './form-element-base';
import '@trumedianetworks/tmn-core-components/src/tmn-input';
import '@trumedianetworks/tmn-core-components/src/tmn-form-group';

class FormElementInput extends FormElement {
    constructor() {
        super();
    }

    static get styles() {
        return [
            ...super.styles,
            css`
                :host {
                    display: flex;
                    flex-flow: column;
                    flex: 1 0 0%;
                }
                :host([type='number']) tmn-input {
                    max-width: 75px;
                }
                tmn-input {
                    max-width: 350px;
                }
            `,
        ];
    }
    static get properties() {
        return {
            type: {
                type: String,
                reflect: true,
            },
        };
    }

    render() {
        const { itemTemplate, isOverrideMode, value, validationError, isReadOnly, type } = this;
        const { isOptional } = itemTemplate;
        const required = !isOptional && !isOverrideMode;
        const displayLabel = this.getDisplayLabel();
        if (this.isViewMode() || isReadOnly) {
            return html`<tmn-form-group>
                <label>${displayLabel}:</label>
                <span>${value}</span>
            </tmn-form-group>`;
        }
        return html`<tmn-input
            .error=${validationError}
            label=${displayLabel}
            ?disabled=${isReadOnly}
            .required=${required}
            .value=${value}
            .type=${type}
            @tmn-input-changed=${this.handleInputChanged}></tmn-input>`;
    }

    handleInputChanged({ detail }) {
        const { value } = detail;
        const { path } = this;
        // I think this is ok, but if not then we can do this operation elswhere. Just trying to prevent saving with trailing or leading spaces
        const cleanValue = value ? value.trim() : value;
        this.actions.setStagedEditByPath(path, cleanValue);
    }
}

customElements.define('form-element-input', FormElementInput);
